/* eslint-disable no-new */

import ProtectedTagEdit from './protected_tag_edit';

export default class ProtectedTagEditList {
  constructor() {
    this.$wrap = $('.protected-tags-list');
    this.initEditForm();
  }

  initEditForm() {
    this.$wrap.find('.js-protected-tag-edit-form').each((i, el) => {
      new ProtectedTagEdit({
        $wrap: $(el),
      });
    });
  }
}



// WEBPACK FOOTER //
// ./protected_tags/protected_tag_edit_list.js